import React from 'react';
import { ReactComponent as ErrorImage } from '@/src/resources/global-error2.svg';
import { sandwichIds } from '@/src/constants/sandwich-ids';

const modify = {
  [sandwichIds.globalErrorPage.image]: () => <ErrorImage />,
};

export { modify };
